import { useState } from "react";
import { CategoryManager } from "@/components/settings/admin/stats/payments/form/CategoryManager";
import { Settings } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PaymentCategoriesSectionProps {
  gymId: string;
}

export const PaymentCategoriesSection = ({ gymId }: PaymentCategoriesSectionProps) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!isOpen) {
    return (
      <Button
        variant="outline"
        className="gap-2"
        onClick={() => setIsOpen(true)}
      >
        <Settings className="h-4 w-4" />
        Gestionar categorías de pago
      </Button>
    );
  }

  return (
    <div className="bg-card border rounded-xl p-4 sm:p-6 space-y-4">
      <CategoryManager gymId={gymId} onBack={() => setIsOpen(false)} />
    </div>
  );
};
